import React from "react";
import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SymbolV2 } from "@rentablo/api/apiv1";
import { Modal } from "@rentablo/components";
import { SecuritiesSearch } from "@features/transactionWizard/components/SecuritySearch/SecuritiesSearch";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSymbolSelect: (symbol: SymbolV2) => void;
};

export const SearchModal = ({ isOpen, onClose, onSymbolSelect }: Props) => {
  const { t } = useTranslation();
  return (
    <Modal
      disablePortal={false}
      isOpen={isOpen}
      onClose={onClose}
      height="auto"
      titleMargin={1}
      title={t("securitiesSearch.title")}
      zIndex={10000}
      width={776}
    >
      <Box mt={2}>
        <SecuritiesSearch onSymbolSelect={onSymbolSelect} />
        <Button
          variant="tertiary"
          onClick={onClose}
          sx={{
            marginTop: (theme) => theme.spacing(4),
          }}
        >
          {t("navigation.previous")}
        </Button>
      </Box>
    </Modal>
  );
};
